import { useState } from "react";
import { motion } from "framer-motion";
import { useLanding } from "@/context/LandingContext";
import { InteractiveSection, MotionBg } from "./MotionBg";
import { Reveal } from "./Reveal";

export function Beliefs() {
  const { t } = useLanding();
  const [active, setActive] = useState(0);
  const item = t.beliefs.items[active];

  return (
    <InteractiveSection className="section section-dark beliefs" data-testid="beliefs-section">
      <MotionBg variant="stars" dots={3} />
      <div className="container">
        <Reveal className="section-head">
          <p className="eyebrow"><span className="eyebrow-no">03</span>{t.beliefs.eyebrow}</p>
          <h2>{t.beliefs.title}</h2>
          <p className="lead">{t.beliefs.lead}</p>
        </Reveal>
        <div className="belief-grid">
          <Reveal className="belief-list">
            {t.beliefs.items.map((belief, index) => (
              <button key={belief.short} type="button" className={`belief-btn ${active === index ? "active" : ""}`} aria-pressed={active === index} onClick={() => setActive(index)} data-testid={`belief-btn-${index}`}>
                <strong>{belief.short}</strong>
                <span>→</span>
              </button>
            ))}
          </Reveal>
          <Reveal className="belief-response" delay={0.1} aria-live="polite" data-testid="belief-response">
            <motion.div key={active} initial={{ opacity: 0.35, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.32, ease: "easeOut" }}>
              <span className="number">{t.beliefs.assumption} 0{active + 1}</span>
              <h3>{item.title}</h3>
              <p>{item.copy}</p>
            </motion.div>
          </Reveal>
        </div>
      </div>
    </InteractiveSection>
  );
}
